import { MutableRefObject, useCallback, useRef } from 'react'
import { Parsed } from "./parsers/types"


const inputStub: HTMLInputElement = {} as any

// 
// input element Proxy:
//   input.value: get, set property
//   inupt.setSelectionRange():
//   input.selectionEnd: get property
//   input.selectionStart: get property
// 


export const useCreateSearchInputProxy = (parsedRef: {parsed:Parsed}) => {
  const originalInputRef = useRef(inputStub)
  const proxyCache = useRef<HTMLInputElement>(null)

  const proxiedSetSelectionRange = useCallback((start:number, end:number, direction?:'forward'|'backward'|'none') => {
    const original = originalInputRef.current
    const ast = parsedRef.parsed.ast
    if (ast.kind === 'Tag') {
      const i = original.value.indexOf('#')
      original.setSelectionRange(start + i, end + i, direction)
      return;
    }
    
    original.setSelectionRange(start, end, direction)
  }, [parsedRef])
  
  const createSearchInputProxy = useCallback((original:HTMLInputElement) => {
    if (originalInputRef.current === original && proxyCache.current !== null) {
      return proxyCache.current
    }
    originalInputRef.current = original
    const proxy = new Proxy(original, {
      get: (target, p) => {
        const ast = parsedRef.parsed.ast
        switch (p) {
          case 'value': {
            if (ast.kind === 'Tag') {
              const i = original.value.indexOf('#')
              return original.value.substring(i + 1)
            }

            if (ast.kind === 'Path') {
              const exprBody = original.value.replace(/^\s*path:\s*/i, '').trimEnd()
              if (exprBody.length === 0 || parsedRef.parsed.error) {
                return ''
              }

              const lookup = [ast.database, ast.schema, ast.table, ast.field]
              const part = lookup[ast.progress]
              return part?.raw || ''
            }

            return original.value
          }

          case 'selectionStart': {
            if (ast.kind === 'Tag') {
              const i = original.value.indexOf('#')
              return original.selectionStart !== null ? Math.max(0, original.selectionStart - i) : null
            }
            
            // if (ast.kind == 'Path') {
            // }

            return original.selectionStart
          }
          case 'selectionEnd': {
            if (ast.kind === 'Tag') {
              const i = original.value.indexOf('#')
              return original.selectionEnd !== null ? Math.max(0, original.selectionEnd - i) : null
            }
            
            // if (ast.kind == 'Path') {
            // }
    
            return original.selectionEnd
          }

          case 'setSelectionRange': {
            return proxiedSetSelectionRange
          }

          default: {
            const prop = (original as any)[p]
            if (typeof prop === 'function') {
              return (prop as Function).bind(original)
            }
            return prop
          }
        }
      },
      set: (target, p, newVal, receiver) => {
        const ast = parsedRef.parsed.ast
        switch (p) {
          case 'value': {
            if (ast.kind === 'Tag') {
              original.value = ast.prefix + newVal
              return true
            }
          }

        };
        (original as any)[p] = newVal
        return true
      },
    });
    (proxyCache as any).current = proxy
    return proxy
  }, [parsedRef])

  const getOriginalInputValue = useCallback(() => {
    return originalInputRef.current.value
  }, [])

  const getProxyInputValue = useCallback(() => {
    return proxyCache.current && proxyCache.current.value
  }, [])
  
  return { createSearchInputProxy, getOriginalInputValue, getProxyInputValue }  
}
